import styled from 'styled-components'

import { RewardsCard } from '../../RewardsCard'

export const Card = styled(RewardsCard)`
  gap: 16px;
  align-items: flex-start;
  flex: 1;
  width: 100%;
`

export const Container = styled.div`
  width: 100%;
  height: auto;
`
